export const mapOrder = (array, order) => {
  array.sort((a, b) => {
    const A = a.studentProfileId;
    const B = b.studentProfileId;

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    }
    return -1;
  });

  return array;
};

export const DEFAULT_QUESTIONS_COUNT = 0;

export const getStudentStatus = (students, id, ljId) => {
  if (students && students.length) {
    const student = students.find(s => s.studentProfileId === id && s.learningJourneyId === ljId);
    if (student !== undefined) return student.studentStatus;
  }
  return 0;
};

export const getStudentInfo = (students, id, ljId) => {
  if (students && students.length) {
    return students.find(s => s.studentProfileId === id && s.learningJourneyId === ljId);
  }
  return {};
};

export const getFirstStatusOccurrences = (selectedTopics = [], students = [], id) => {
  const statuses = {};
  selectedTopics[0].childTopics.forEach((topics) => {
    topics.childTopics.forEach((question) => {
      students.forEach((s) => {
        if (s.studentProfileId === id && s.learningJourneyId === question.id && !statuses[s.studentStatus]) {
          statuses[s.studentStatus] = question.id;
        }
      });
    });
  });
  return statuses;
};
